import * as Sentry from "@sentry/gatsby";

Sentry.init({
  dsn: process.env.GATSBY_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  enabled: !!process.env.GATSBY_SENTRY_DSN,

  integrations: [
    Sentry.browserTracingIntegration(),
  ],

  // 10% des transactions en prod pour le performance monitoring
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,

  // Captures les erreurs non gérées
  beforeSend(event) {
    // Ignore les erreurs de navigateurs vieillissants / extensions
    if (event.exception?.values?.[0]?.value?.includes("ResizeObserver loop")) {
      return null;
    }
    return event;
  },
});
